import React from 'react';

export default function BetSlipIcon() {
  return (
    <svg className="betslip-icon icon" id="betslip-icon" viewBox="0 0 20 23" xmlns="http://www.w3.org/2000/svg">
      <title>BetSlip</title>
      <path d="M15.666 0H1.626C.77 0 0 .813 0 1.645v16.75C0 19.23.772 20 1.625 20h14.04c.856 0 1.647-.77 1.647-1.604V1.646c0-.833-.79-1.646-1.646-1.646zM3.314 16H13.98v-1.313H3.314V16zm0-3.313H13.98v-1.354H3.314v1.354zM16 18.02c0 .626-.437.668-.604.668H1.917c-.188 0-.604-.042-.604-.667V5.334H16V18.02zM3.314 9.355H13.98V8H3.314v1.354z" fillRule="evenodd"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./modules/Common/components/svg/BetSlipIcon.js